import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormGroup,  FormBuilder, Validators } from "@angular/forms";
import { AdminService } from "../../../../services/admin.service";
import { apiUrl } from "../../../../global/global";
import { HttpParams } from "@angular/common/http";
import { UserDetailsService } from "src/app/services/user/user-details.service";
import { Subject } from "rxjs";
@Component({
  selector: "app-inventory-plan",
  templateUrl: "./inventory-plan.component.html",
  styleUrls: ["./inventory-plan.component.css"]
})
export class InventoryPlanComponent implements OnInit {

  allPlans: any = [];
  form: FormGroup; 
  amount: any;
  clicks:any;
  planId: any;
  selectedID: any;
  subscriptionObserver = new Subject<string>();
  public userDatas: any;
  public userPermissionData: any; 
  selectedDuration = "Please select"
  constructor(public route: ActivatedRoute,private router: Router,private api: AdminService,private formBuilder: FormBuilder,private userDetailsService: UserDetailsService) { 
    
    this.userDetailsService.getRecruiterUserData();
    this.userDetailsService.userDetailsObserver.subscribe(userData => {
      this.userDatas = userData; 
    });
    this.userDetailsService.getRecruiterPermission();
    this.userDetailsService.userPermissionObserver.subscribe(res => {
      this.userPermissionData = res; 
    }); 
    this.form = this.formBuilder.group({
      id:[""]
    })
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['subscriptionId']){
      this.allPlans = params['subscriptionId']; 
      this.planId = params['subscriptionId']; 
      this.selectedID =this.planId; 
      this.getPlans()
    }
  });
    this.getPlans();
  }

  getPlans(){
    let params = new HttpParams(); 
    params = params.append("planType", "1");
    this.api.getData(apiUrl._paymentPlan,params)
    .subscribe(async (res) => {
      this.allPlans = res.data.data;  
      this.allPlans.map((amt)=>{
        if(this.selectedID == amt.id){
          this.selectedID =amt.id;
          this.amount = amt.planAmount;
          this.clicks = amt.numberOfClicks;
          this.allPlans.push(amt)
        }
        
      }) 
      this.form.patchValue({
        ...this.allPlans,
        id:this.selectedID})
    })
  }
  change(event){
    this.planId= event.target.value;
    this.allPlans.map((amt)=>{
      if(amt.id == event.target.value){
        this.amount = amt.planAmount;
        this.clicks = amt.numberOfClicks;
      }
    })
  }
  //  submit
  redirectTo(){
    // this.router.navigateByUrl(`/account-settings/checkout/inventory/${this.planId}`,qu
    let queryparams = {}
    queryparams["type"] = "inventory";
    this.router.navigate(["/account-settings/checkout/inventory/" + this.planId], {queryParams : queryparams})
  }
}